const Arrow = require('assets/resources/ArrowRight.svg').default;

/**
 * @description Hiển thị
 * @returns {JSX.Element} List time component
 */
const ListTime = ({ activeIndex, setActiveIndex, listTime }) => {
  return (
    <div className="w-full bg-white h-full p-2">
      <ul className="h-full w-full overflow-y-auto p-2">
        {listTime.map((item, index) => (
          <li
            className={`w-full h-12 flex items-center justify-between break-all px-4 hover:bg-teal-444/20 cursor-pointer ${activeIndex === index ? 'bg-teal-444/20' : ''}`}
            key={index}
            onClick={() => setActiveIndex(index)}
          >
            {item}
            <img src={Arrow} alt="arrow" width={16} height={16} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ListTime;
